import { Statistic } from '../components/StockTable';
import { TECHNICAL_STATISTICS } from './technicalsTabUtils';

export interface TickerStatisticsColumnWidthOptions {
  statistics: Statistic[];
  isEditingColumns: boolean;
  isSmallScreen: boolean;
  hasProTags?: boolean;
}

/** Shared first-column width logic for single-ticker table pages. */
export function calculateTickerStatisticsColumnWidth({
  statistics,
  isEditingColumns,
  isSmallScreen,
  hasProTags = false,
}: TickerStatisticsColumnWidthOptions): number {
  const longestLabel = statistics.reduce(
    (longest, stat) => (stat.label.length > longest.length ? stat.label : longest),
    ''
  );

  const proTagSpace = hasProTags ? 40 : 0;

  const baseWidth = longestLabel.length * 8;
  const padding = 32;
  const buffer = 20;
  const checkboxWidth = isEditingColumns ? 40 : 0;

  const calculatedWidth = baseWidth + padding + buffer + checkboxWidth + proTagSpace;

  if (isSmallScreen) {
    const compactBaseWidth = longestLabel.length * 6;
    const compactPadding = 12;
    const compactEditButtonSpace = isEditingColumns ? 28 : 0;
    const compactBuffer = 12;
    const compactProTagSpace = hasProTags ? 28 : 0;

    const calculatedCompactWidth =
      compactBaseWidth + compactPadding + compactEditButtonSpace + compactBuffer + compactProTagSpace;
    const reducedWidth = calculatedCompactWidth * 0.75;

    return Math.max(100, reducedWidth + 10);
  }

  return Math.max(120, calculatedWidth);
}

/** TickerTechnicals reference width (used to align other ticker tabs on small screens). */
export function calculateTickerTechnicalsStatisticsColumnWidth(
  isEditingColumns: boolean,
  isSmallScreen: boolean
): number {
  return calculateTickerStatisticsColumnWidth({
    statistics: TECHNICAL_STATISTICS,
    isEditingColumns,
    isSmallScreen,
    hasProTags: true,
  });
}
